import { useState } from 'react';
import { OptionsType } from '../../types/options';
import optionsAPI from '../../api/optionsAPI';
import getAsyncErrorMessage from '../../utils/getAsyncErrorMessage';

export const useCustomerOptions = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [options, setOptions] = useState<OptionsType[]>([]);

  const getCustomerOptions = async (organizationId: number): Promise<void> => {
    setIsLoading(true);
    try {
      const response = await optionsAPI.getCustomerOptions(organizationId);
      setOptions(response.data);
    } catch (err) {
      const errorMessage: string = getAsyncErrorMessage(err);
      setHasError(true);
      setMessage(errorMessage);
    }
    setIsLoading(false);
  };

  const resetMessage = (): void => {
    setHasError(false);
    setMessage('');
  };

  return { options, getCustomerOptions, isLoading, hasError, message, resetMessage };
};
